module.exports = require("pify");


//////////////////
// WEBPACK FOOTER
// external "pify"
// module id = 7
// module chunks = 0